import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Button, Card, Container } from "react-bootstrap";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const formatDate = (d) => {
  if (!d) return "-";
  const dt = new Date(d);
  return Number.isNaN(dt.getTime()) ? "-" : dt.toLocaleDateString();
};

export default function DriverDisclosureList() {
  const navigate = useNavigate();
  const { id: paramId } = useParams();

  const role = localStorage.getItem("userRole");
  const isAdmin = role === "1";
  const loggedInId = localStorage.getItem("userId");
  const userId = isAdmin && paramId ? paramId : loggedInId;

  const [records, setRecords] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${API_BASE}/api/driver-disclosure/${userId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        setRecords(res.data || []);
      } catch (err) {
        console.error("❌ Driver Disclosure list fetch error", err);
      }
    };
    fetchData();
  }, [userId]);

  const handleReturn = () => {
    if (isAdmin && paramId) navigate(`/userhome/${paramId}`);
    else navigate("/userhome");
  };

  const rows = useMemo(() => records ?? [], [records]);

  return (
    <Container className="form-wrapper my-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h3 className="mb-0">Driver Disclosure</h3>
        <div className="d-flex gap-2">
          <Button variant="secondary" onClick={handleReturn}>
            ⬅ Return
          </Button>
          <Button
            variant="success"
            onClick={() => navigate(`/driver-disclosure/${userId}/new`)}
          >
            ➕ Add
          </Button>
        </div>
      </div>

      <Card>
        <Card.Body>
          {!rows.length ? (
            <div className="text-muted text-center">No records found.</div>
          ) : (
            <div className="table-responsive">
              <table className="table table-striped table-bordered">
                <thead className="table-light">
                  <tr>
                    <th style={{ width: "6%" }}>#</th>
                    <th style={{ width: "15%" }}>Date Saved</th>
                    <th style={{ width: "20%" }}>Saved By</th>
                    <th style={{ width: "15%" }}>Date Created</th>
                    <th style={{ width: "20%" }}>Created By</th>
                    <th style={{ width: "14%" }}>Violations</th>
                    <th style={{ width: "10%" }}></th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((r, idx) => (
                    <tr key={r.dd_id}>
                      <td>{idx + 1}</td>
                      <td>{formatDate(r.dd_saved_date)}</td>
                      <td>{r.saved_by || "-"}</td>
                      <td>{formatDate(r.dd_created_date)}</td>
                      <td>{r.created_by || "-"}</td>
                      <td>{r.dd_no_violations ? "No" : "Yes"}</td>
                      <td>
                        <Button
                          size="sm"
                          variant="outline-primary"
                          onClick={() =>
                            navigate(
                              `/driver-disclosure/${userId}/detail/${r.dd_id}`
                            )
                          }
                        >
                          Edit
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
}
